import "../../../css/buttons/PrimaryButton.css";

const PrimaryButton = ({ onClick, text }) => {
  return (
    <button className="primary-button" onClick={onClick}>
      <div className="nav-bold">{text}</div>
    </button>
  );
};

export default PrimaryButton;
